import {Factory} from './Factory'
import Menu from '../EditorElements/ColumnModule/Menu'

export class ColumnFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  create(data) {
    this.columns = this.mapColumns(data)
    let columns = this.columns.map(column => {
      let id = this.id('column')
      return {...column, id}
    })
    return columns
  }

  mapColumns(data) {
    if (data) {
      return data
    }

    let columns = []
    for (let x = 1; x <= this.qty; x++) {
      columns.push(this.markup(x))
    }
    return columns
  }

  markup() {
    return {
      name: 'column',
      properties: {
        styles: [
          {key: 'background', component: 'BackgroundProperty'},
          {key: 'border', component: 'BorderProperty'},
          {key: 'padding', component: 'PaddingProperty'},
          {key: 'margin', component: 'MarginProperty'},
          {key: 'display', component: 'DisplayInDeviceProperty', class: 'containerClasses'},
        ],
        advanced: [
          {key: 'element-id', component: 'ElementId'},
          {key: 'custom-classes', component: 'CustomClasses'},
          {key: 'custom-styles', component: 'CustomStyles'},
        ],
        menu: Menu
      },
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      styles: {
        phone: [],
        tablet: [],
        desktop: []
      },
      classes: {
        phone: [
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
        ],
        tablet: [
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
        ],
        desktop: [
          {property: 'PaddingTop', value: 'PADDING_TOP_NONE'},
          {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE'},
          {property: 'PaddingBottom', value: 'PADDING_BOTTOM_NONE'},
          {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE'},
        ]
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      components: [],
      customClasses: [],
      containerClasses: {
        phone: [
          { property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }
        ],
        tablet: [
          { property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }
        ],
        desktop: [
          { property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
        ]
      }
    }
  }
}